import React, { Component } from 'react';
import Modal from 'react-responsive-modal';

import NavBar from '../../components/navigation/NavBar';
import RateView from '../../components/rateview/RateView';
import ApiResponse from '../../components/message/ApiResponse';

import { getCurrentResource } from '../../util/tools';
import { isSuperUser } from '../../util/localStorage';
import { performApiRequestForm, ACTION_ROLE_IMPORT_API_URL } from '../../util/restapi';

import {
	FORM_ROLE_TABLE
} from '../../util/consts/forms';

import iconImport from '../../assets/icons/png24x24/get_message.png';

const MODAL_MODE_ACTIVE = 'a';
const MODAL_MODE_WAIT = 'w';
const MODAL_MODE_COMPLETE = 'c';

class RoleListPage extends Component {
	constructor(props) {
		super(props);

		this.resource = getCurrentResource().pages.tableform.RoleList;
		let paramCacheId = props.match.params.param;

		this.rvContext = {
			form: FORM_ROLE_TABLE,
			data: []
		}
		this.rvOptions = {
			form: FORM_ROLE_TABLE,
			formTitle: this.resource.formTitle,
			paramCacheId: paramCacheId,
			transition: null,
			//hideButtonAdd: true,
			//hideButtonEdit: true,
			hideButtonMergeInstances: true,
			hideButtonChangeOwner: true,
			hideButtonFieldUpdate: true,
			hideButtonGlobalIdUpdate: true,
			//hideButtonDelete: true,
			hideButtonShowHtml: true,
			hideButtonHtml: true,
			hideButtonPdf: true,
			hideButtonXml: true,
			//hideButtonTransition: true,
			//hideButtonUshExport: true,
			//hideButtonUshImport: true,
			hideButtonSendEmail: true,
			controlPanelTools: this.controlPanelTools(),
		};

		this.refImportModal = React.createRef();
		this.state = {
			isImportModalOpen: false,
		}
	}
	componentDidMount() {
		document.title = 'BOM. ' + this.resource.formTitle;
	}
	openImportModal = () => {
		this.refImportModal.current.initModal();
		this.setState({ isImportModalOpen: true });	
	}
	closeImportModal = () => {
		this.setState({ isImportModalOpen: false });	
	}

	controlPanelTools = () => {
		return (
			<div style={{textAlign: 'left', marginLeft: '20px'}}>
				<ButtonImport holder={this} />
			</div>			
		);
	}
	
	
	render() {
		return (
			<React.Fragment>
				<NavBar app={this.props.app} />
				<RateView rvContext={this.rvContext} rvOptions={this.rvOptions} app={this.props.app}  />
				<ImportModal ref={this.refImportModal} page={this} 
					isModalOpen={this.state.isImportModalOpen} 
					close={this.closeImportModal} 
				/>
			</React.Fragment>
		)
	}
	
}

class ImportModal extends React.Component {

	constructor(props) {
		super(props);
		this.resource = props.page.resource;
		this.fileImportRef = React.createRef();
		this.file = null;
		this.response = null;
		this.state = {
			modalMode: MODAL_MODE_ACTIVE,
			fileName: this.resource.textSelectFile,
			format: "l3",
		}
	}
	initModal = () => {
		this.file = null;
		this.response = null;
		this.setState({
			modalMode: MODAL_MODE_ACTIVE,
			fileName: this.resource.textSelectFile,
			format: "l3",
		});
	}
	tryAgain = () => {
		this.setState({	modalMode: MODAL_MODE_ACTIVE});
	}

	handleFileSelect = (e) => {
		let files = e.target.files;
		if( files && files.length > 0 ) {
			this.file = files[0];
			this.setState({fileName: this.file.name})
		}
	}	

	startImport = async () => {
		this.setState({modalMode: MODAL_MODE_WAIT})
		const form = new FormData();
		form.append('file', this.file);
		this.response = await performApiRequestForm(ACTION_ROLE_IMPORT_API_URL, form);
		this.setState({modalMode: MODAL_MODE_COMPLETE})
	}

	render() {
		let resource = this.resource;
		let divWaiting = null;
		let modalBodyHtml;
		if( this.state.modalMode == MODAL_MODE_COMPLETE ) {
			modalBodyHtml = (
				<React.Fragment>
					<ApiResponse response={this.response} defaultMessage={resource.messageImportComplete} />
					<div style={{marginTop: '7px', padding: '10px', marginRight: '15px', textAlign: 'right'}}>
						<button type='button' onClick={this.tryAgain} >
							{resource.buttonTryAgain}
						</button>
					</div>
				</React.Fragment>
			);
		} else {
			let buttonImportDisabled = this.state.modalMode == MODAL_MODE_WAIT || this.file == null;
			if( this.state.modalMode == MODAL_MODE_WAIT )
				divWaiting = (<div style={{textAlign: 'center',	padding: '7px'}}>{resource.waiting}</div>);  
			modalBodyHtml = (
				<div style={{margin: '15px'}}>
					<div>
						{resource.labelFile}: 
						<span style={{marginLeft: '5px', marginRight: '10px'}}>{this.state.fileName}</span> 
						<button onClick={e => this.fileImportRef.current.click()}>...</button>
						<input ref={this.fileImportRef} type={'file'}  style={{display: 'none'}} 
							onChange={e => this.handleFileSelect(e)} 
						/>
					</div>
					{divWaiting}
					<div style={{marginTop: '7px', padding: '10px', marginRight: '15px', textAlign: 'right'}}>
						<button type='button' title={resource.buttonImportTooltip}
							onClick={this.startImport} disabled={buttonImportDisabled}
						>
							{resource.buttonImport}
						</button>
					</div>
				</div>
			);
		}
		return (
			<Modal 
				open={this.props.isModalOpen} onClose={this.props.close} center 
				styles={styleModal} closeOnOverlayClick={false} animationDuration={1} 
			>
				<div>
					<div style={localStyles.divHeader}>
						{this.resource.modalImportTitle}
					</div>
					{modalBodyHtml}
				</div>
			</Modal>
		);
	}
}

function ButtonImport(props) {
	
	if( isSuperUser() ) {
		return (
			<button type='button' style={{marginLeft: '5px', width: '36px', height: '30px'}}
				 onClick={props.holder.openImportModal}
				 title={props.holder.resource.buttonImportTooltip} 
			>
				<img src={iconImport} />
			</button>			
		);
	} else {
		return null;
	}
}

const localStyles = {
	divHeader: {
		fontSize: '16pt',
		textAlign: 'center',
		padding: '10px',
		borderRadius: '21px 21px 0 0',
		backgroundColor: '#F0F0F0'
	},
};

const styleModal = {
	modal: {
		background: '#ffffff',
		padding: '0px',
		borderRadius: '21px',
		maxWidth: '500px',
		width: '100%',
	},
	closeButton: {
		top: '10px',
		right: '10px',
		fill: '#FF0000',
		outline: 'none',
	},
};

export default RoleListPage;
